import { render, staticRenderFns } from "./CardStats.vue?vue&type=template&id=75a19618&scoped=true&"
import script from "./CardStats.vue?vue&type=script&lang=js&"
export * from "./CardStats.vue?vue&type=script&lang=js&"
import style0 from "./CardStats.vue?vue&type=style&index=0&id=75a19618&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a19618",
  null
  
)

export default component.exports